import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Server from './components/Server'
import styles from '../../styles.scss'

class Menu extends Component {
    constructor(props) {
        super(props)

        this.listenerExists = false
        if (!props.noMenu) {
            this.addListener()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.noMenu !== this.props.noMenu) {
            if (this.props.noMenu) {
                this.removeListener()
            } else {
                this.addListener()
            }
        }
    }

    componentWillUnmount() {
        this.removeListener()
    }

    addListener() {
        if (!this.listenerExists) {
            document.addEventListener('mousedown', this.handleClickOutside)
            this.listenerExists = true
        }
    }

    removeListener() {
        if (this.listenerExists) {
            document.removeEventListener('mousedown', this.handleClickOutside)
            this.listenerExists = false
        }
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.closeMenu()
        }
    }

    renderOpenMenu() {
        // If the menu is not open, do nothing
        if (!this.props.isOpen) return null

        // Create the servers
        return this.props.inactiveServers.map(serverId => (
            <Server key={serverId} serverId={serverId} />
        ))
    }

    renderMenu() {
        // generate the necessary classes for the menu
        let classes = `${styles.server_selector} ${styles.menu}`
        if (this.props.isOpen) {
            classes += ` ${styles.open}`
        }

        return (
            <ul className={classes} ref={ref => (this.wrapperRef = ref)}>
                <Server serverId={this.props.activeServerId} />
                {this.renderOpenMenu()}
                <li />
            </ul>
        )
    }

    renderSingleServer() {
        // generate the necessary classes for open/closed drop-down
        const classes = styles.server_selector

        return (
            <ul className={classes} ref={ref => (this.wrapperRef = ref)}>
                <Server serverId={this.props.activeServerId} noMenu />
            </ul>
        )
    }

    render() {
        // If servers are missing, render nothing
        if (this.props.activeServerId == null || this.props.activeServerId === '') return null

        return this.props.noMenu ? this.renderSingleServer() : this.renderMenu()
    }
}

Menu.propTypes = {
    noMenu: PropTypes.bool,
    isOpen: PropTypes.bool,
    activeServerId: PropTypes.string,
    inactiveServers: PropTypes.arrayOf(PropTypes.string),
    closeMenu: PropTypes.func,
}

export default Menu



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/component.js